export default {
      id: "263,4_cm_=_90_+_90_+_80-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#263,4_cm_=_90_+_90_+_80",
      toString: function () {
        return this.url;
      }
    }